import animalsBundle from '../content/animals/activities.json';
import roboticsBundle from '../content/robotics/activities.json';
import mathBundle from '../content/math/activities.json';

/** Content `type` → miniAppRegistry key */
const TYPE_TO_MINIAPP = {
  quiz: 'engine_multiple_choice',
  sequencing: 'engine_sequence',
  drag_drop: 'engine_match',
  exploration_card: 'engine_exploration_cards',
  pattern: 'engine_pattern',
  canvas: 'engine_canvas_manipulative',
  canvas_manipulative: 'engine_canvas_manipulative',
  tap_on_image: 'engine_tap_on_image',
  hotspots: 'engine_tap_on_image',
  simulation: 'engine_simulation_scrub',
  simulation_scrub: 'engine_simulation_scrub',
  gear: 'engine_gear_ratio',
  gear_ratio: 'engine_gear_ratio',
  circuit: 'engine_circuit_builder',
  circuit_builder: 'engine_circuit_builder',
  system_flow: 'engine_system_flow',
  variable_simulation: 'engine_variable_simulation',
  evidence_detective: 'engine_evidence_detective',
};

/** worldId + learning path id → curated activity id in src/content/<world>/activities.json */
const PATH_TO_ACTIVITY_ID = {
  'animals:animal-habitats': 'an-a-habitat-match',
  'animals:what-do-animals-eat': 'an-a-diet-quiz',
  'animals:animal-adaptations': 'an-a-adaptation-cards',
  'robotics:robot-path-sequencing': 'ro-a-path-sequence',
  'robotics:sensors-and-signals': 'ro-a-sensors-signals-quiz',
  'math:number-patterns': 'ma-a-number-patterns',
  'math:shape-detective': 'ma-a-shape-detective',
  'math:multiplication-adventure': 'ma-a-multiplication-adventure',
};

function indexActivities(bundle) {
  const m = Object.create(null);
  for (const a of bundle.activities || []) {
    m[a.id] = a;
  }
  return m;
}

const BY_WORLD = {
  animals: indexActivities(animalsBundle),
  robotics: indexActivities(roboticsBundle),
  math: indexActivities(mathBundle),
};

function hintsFromActivity(activity) {
  const texts = [];
  for (const h of activity.aiHints || []) {
    for (const msg of h.messages || []) {
      if (msg.text) texts.push(msg.text);
    }
  }
  return texts;
}

/**
 * @param {string} worldId
 * @param {string} pathId - LearningPathCard path.id
 * @returns {{ app: string, props: { title: string, content: object, hints: string[], activityId: string } } | null}
 */
export function getMiniAppForLearningPath(worldId, pathId) {
  if (!worldId || !pathId) return null;
  const activityId = PATH_TO_ACTIVITY_ID[`${worldId}:${pathId}`];
  if (!activityId) return null;
  const activity = BY_WORLD[worldId]?.[activityId];
  if (!activity) return null;
  const app = TYPE_TO_MINIAPP[activity.type];
  if (!app) return null;
  return {
    app,
    props: {
      title: activity.title,
      content: activity.content,
      hints: hintsFromActivity(activity),
      activityId: activity.id,
    },
  };
}
